import { IssuecardComponent } from '../issuecard/issuecard.component';
import { SynchronizationService } from '../../services/synchronization.service';
import { HTMLElementPositioningHelper } from '../../util/htmlelement-positioning-helper';
import { EventIssuecardOpened } from '../../models/syncEvents/realtimeEvents/eventIssuecardOpened';
import { DynamicElementService } from '../../services/dynamicElement.service';
import {OnlineuserService} from '../../services/onlineuser.service';


/**
 * Helper class encapsulating synchronisation-related tasks for issue.component
 */
export class IssueSynchroHelper {

  static sendIssueCardOpenedEvent(syncService: SynchronizationService, issueCard: IssuecardComponent,
    positionHelper: HTMLElementPositioningHelper, onlineuserService: OnlineuserService): void {

    const parentId = (issueCard.issue.isSubissue ? issueCard.issue.parentIssueId : null);
    const position = positionHelper.getRelativePositionOfElement(issueCard.getElementRef().nativeElement);
    const event = new EventIssuecardOpened(issueCard.issue.id, parentId, issueCard.issue.isSubissue, position,
      onlineuserService.getAvatarUrl());
    syncService.sendRealTimeEventNew(event);
  }

  static handleIssueCardOpenedEvent(
    event: EventIssuecardOpened,
    dynamicElementService: DynamicElementService,
    positionHelper: HTMLElementPositioningHelper,
    callbackDynamicallyAddCard) {

    // Dont open a new card if a card for this issue already exists
    if (dynamicElementService.containsIssuecardForIssue(event.issueId)) {
      return;
    }
    const card: IssuecardComponent = callbackDynamicallyAddCard();
    const cardElement = card.getElementRef().nativeElement;
    positionHelper.setRelativePosition(cardElement, event.position.left, event.position.top);
    dynamicElementService.select(card.componentRef);
  }

}
